import { Grid, TextField, Typography } from '@mui/material';
import React from 'react'
import Required from '../../../../../utility/required';
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import contactStyles from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import { CombinedUpdateType, combinedValueType } from './variableAssignmentPopup';

interface RenderStaticValueFieldProps {
    getValueOfFields: (type: combinedValueType) => any,
    onChangeOfFields: ({ type, value }: CombinedUpdateType) => void,
} 

const RenderStaticValueField: React.FC<RenderStaticValueFieldProps> = (props) => {
    
    const { getValueOfFields, onChangeOfFields } = props;

    return (
        <>
            <Grid item xs={12}>
                <Grid container gap={1}>
                    <Grid item xs={12}>
                        <Typography className={styles.createWorkflowLabelStyle}>Static Value <Required /></Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            value={getValueOfFields("static value") as string}
                            onChange={(event) => onChangeOfFields({ type: "static value", value: event.target.value })}
                            placeholder="Enter Static Value"
                            className={`${contactStyles.campaignContactPopupTextField} ${globalStyles.fullwidth}`} 
                        />
                    </Grid>
                </Grid>
            </Grid> 
        </>
    )
}

export default RenderStaticValueField
